import { render, staticRenderFns } from "./SpotlightElementRoot.vue?vue&type=template&id=1548acdd"
import script from "./SpotlightElementRoot.vue?vue&type=script&lang=ts"
export * from "./SpotlightElementRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports